import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdArrowBackIos,
  MdArrowForwardIos,
  MdBookmark,
  MdBookmarkBorder,
  MdEdit,
  MdHome,
  MdMenu,
  MdOutlineShoppingCart,
  MdPerson,
  MdPersonOutline,
  MdShoppingCart,
  MdVideocam,
} from "react-icons/md";

import "../styles/Seller.css";
import { isEmpty } from "../functions/isEmpty";
import { useLocation, useNavigate } from "react-router";
import VideoRecorder from "../components/VideoRecorder";
import Bottombar from "../components/Bottombar";

export default function SellerHome({
  isMobile,
  apiURL,
  authToken,
  creators,
  services,
  templates,
  categories,
  orders,
  companyData,
  scrollPositionSeller,
  setScrollPositionSeller,
  becomeSellerActive,
  setBecomeSellerActive,
  isSeller,
  setIsSeller,
}) {
  let navigate = useNavigate();
  let location = useLocation().pathname;

  const [servicesAndTemplates, setServicesAndTemplates] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);

  useEffect(() => {
    if (isEmpty(authToken)) {
      navigate("/becomeSeller");
    }

    if (!isEmpty(companyData) && companyData.isACreator != 1) {
      navigate("/becomeSeller");
    }
  }, [authToken, companyData]);

  useEffect(() => {
    if (!isEmpty(companyData)) {
      // Step 1: Filter out services that do not match the companyData.id
      const filteredServices = services.filter(
        (service) => service.company_id === companyData.id
      );

      // Step 2: Extract template IDs from the filtered services
      const serviceTemplateIds = filteredServices.map(
        (service) => service.template_id
      );

      // Step 3: Filter templates that are not already used by services
      const filteredTemplates = templates.filter(
        (template) => !serviceTemplateIds.includes(template.id)
      );

      // Step 4: Combine the filtered services and the filtered templates
      const resultArray = [...filteredServices, ...filteredTemplates];

      // Step 5: Update the state
      setServicesAndTemplates(resultArray);

      if (
        !isEmpty(services) &&
        !isEmpty(templates) &&
        isEmpty(filteredServices) &&
        becomeSellerActive
      ) {
        navigate("/create/201");
      }
    }
  }, [services, templates, companyData]);

  const isWordInArray = (wordArrayString, searchWord) => {
    try {
      // Parse the string into an array
      const wordArray = JSON.parse(wordArrayString);

      // Check if the word exists in the array
      return wordArray.includes(searchWord);
    } catch (error) {
      console.error("Invalid input format:", error);
      return false;
    }
  };

  function filterByKeyValue(array, key, value) {
    return array.filter((item) => item[key] == value);
  }

  useEffect(() => {
    if (!isEmpty(companyData) && !isEmpty(orders)) {
      setFilteredOrders(filterByKeyValue(orders, "seller_id", companyData.id));
    }
  }, [orders, companyData]);

  const countEarnings = () => {
    let count = 0;
    filteredOrders.map((order) => {
      count = count + parseInt(order.seller_price);
    });
    return count;
  };

  // Function to save the current scroll position
  const handleNavigateClick = (destination) => {
    setScrollPositionSeller(window.scrollY);
    window.scrollTo(0, 0);
    navigate(destination);
  };

  // Effect to scroll to the saved position on component mount
  useEffect(() => {
    window.scrollTo(0, scrollPositionSeller);
  }, [scrollPositionSeller]);

  return (
    <div className="seller">
      {isMobile ? (
        <div>
          <div className="seller_topnav">
            <div
              className="seller_topnav_logo"
              onClick={() => handleNavigateClick("/")}>
              <BackIcon /> Deine Stories
            </div>
            <div
              className="seller_topnav_right"
              onClick={() => handleNavigateClick("/sellerprofile")}>
              <div className="seller_topnav_right_button">
                <PersonIcon />{" "}
                {!isEmpty(companyData) && companyData.instagramProfileURL}
              </div>
            </div>
          </div>
          <div className="seller_secondtopnav">
            <div className="seller_secondtopnav_left">Einnahmen</div>
            <div className="seller_secondtopnav_right">{countEarnings()}€</div>
          </div>
        </div>
      ) : (
        <div className="seller_topnav">
          <div className="seller_topnav_left_title">Stories </div>

          <div className="seller_topnav_right">
            <div className="seller_topnav_right_earnings button">Einnahmen</div>
            {isEmpty(authToken) ? (
              <div
                className="seller_topnav_right_account button"
                onClick={() => handleNavigateClick("/login")}>
                Login
              </div>
            ) : (
              <>
                {!isEmpty(companyData) && companyData.isACreator == 0 ? (
                  <div
                    className="seller_topnav_right_account button"
                    onClick={() => handleNavigateClick("/menu")}>
                    Menu
                  </div>
                ) : (
                  <div
                    className="seller_topnav_right_account button"
                    onClick={() => handleNavigateClick("/sellerprofile")}>
                    {" "}
                    {!isEmpty(companyData) && companyData.instagramProfileURL}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}

      <div className="seller_body">
        <div className="seller_body_list">
          <div className="seller_body_list_sectionTitle">Deine Aufträge</div>
          {isEmpty(filteredOrders) && "Du hast bisher keine Stories verkauft"}
          <div className="seller_body_list_orders">
            {filteredOrders.map((order) => (
              <div
                key={order.id}
                className={
                  isEmpty(order.fulfillment_deliveryurl)
                    ? "seller_body_list_orders_listelementActive button"
                    : "seller_body_list_orders_listelement button"
                }
                onClick={() => handleNavigateClick("/orders/" + order.id)}>
                <div className="seller_body_list_orders_listelement_left">
                  <img
                    src={order.service_img_url}
                    className="seller_body_list_orders_listelement_left_img"
                  />
                </div>
                <div className="seller_body_list_orders_listelement_right">
                  {order.service_title}
                  <br />
                  {isEmpty(order.fulfillment_deliveryurl)
                    ? "Abschließen"
                    : "Abgeschlossen"}
                </div>
              </div>
            ))}
          </div>

          <div
            className="seller_body_list_sectionTitle"
            style={{ paddingTop: "18px" }}>
            Stories erstellen
          </div>

          {categories.map((category) => (
            <div className="home_body_list_row">
              <div className="seller_body_list_row_title">{category}</div>
              <div className="seller_body_list_row_list">
                {servicesAndTemplates.map((template) => (
                  <>
                    {isWordInArray(template.category_id, category) && (
                      <div
                        key={template.id}
                        className="seller_body_list_row_list_element button"
                        onClick={() =>
                          isEmpty(template.prompter_text)
                            ? handleNavigateClick(
                                "/create/" + template.id + "?edit=true"
                              )
                            : handleNavigateClick("/create/" + template.id)
                        }>
                        <div className="seller_body_list_row_list_element_left">
                          <div className="seller_body_list_row_list_element_left_imgbox">
                            {isEmpty(template.preview_img_url) ? (
                              <VideoCamIconDesktop />
                            ) : (
                              <img
                                src={template.preview_img_url}
                                className="seller_body_list_row_list_element_left_imgbox_img"
                              />
                            )}
                          </div>
                          <div className="seller_body_list_row_list_element_left_text">
                            {template.title}
                          </div>
                        </div>
                        <div className="seller_body_list_row_list_element_right">
                          {isMobile && <ArrowForwardIcon />}
                        </div>
                      </div>
                    )}
                  </>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 30px;
  color: #474747;
`;

const ArrowForwardIcon = styled(MdArrowForwardIos)`
  font-size: 18px;
  color: #474747;
`;

const BackIcon = styled(MdArrowBackIos)`
  font-size: 18px;
  color: #474747;
`;

const EditIcon = styled(MdEdit)`
  font-size: 18px;
  color: #474747;
`;

const VideoCamIcon = styled(MdVideocam)`
  font-size: 24px;
  color: #ffffff;
`;

const VideoCamIconDesktop = styled(MdVideocam)`
  font-size: 40px;
  color: #ffffff;
`;

const HomeIcon = styled(MdHome)`
  font-size: 30px;
  color: #474747;
`;

const PersonIcon = styled(MdPerson)`
  font-size: 30px;
  color: #474747;
`;
